import {
  getCurrentUser,
  fetchAuthSession,
  fetchUserAttributes,
} from 'aws-amplify/auth';
import { CurrentUser } from '@/models/global/currentUser';
/**
 * ログイン中のユーザー情報を取得する
 * @returns ログイン中のユーザー情報 (ログインしていなければ空文字)
 */
export const currentUser = async () => {
  try {
    // const session = await Auth.currentAuthenticatedUser({ bypassCache: true }); // bypassCache: 最新情報を取得するにはtrueが必要です。
    const user = await getCurrentUser();
    const session = await fetchAuthSession();
    const attributes = await fetchUserAttributes();

    const currentUser = {
      username: attributes.preferred_username
        ? attributes.preferred_username
        : user.username,
      email: attributes.email,
      imageUrl: attributes.picture,
      timezone: attributes.zoneinfo,
      groups: session.tokens?.idToken?.payload['cognito:groups'] || [],
    } as CurrentUser;
    return currentUser;
  } catch (error) {
    return null;
  }
};
